/**
 * Calculate if onboarding is completed by comparing done steps with all available steps
 */
export const calculateOnboardingCompletion = (
    onboardingStepsDone: string[] | undefined | null,
    allOnboardingSteps: Array<{ slug: string }> | undefined | null,
): boolean => {
    // Safety checks for undefined/null values
    if (!allOnboardingSteps || !Array.isArray(allOnboardingSteps)) {
        return true; // No steps to complete or invalid data
    }

    if (!onboardingStepsDone || !Array.isArray(onboardingStepsDone)) {
        return false; // No steps completed or invalid data
    }

    if (allOnboardingSteps.length === 0) {
        return true; // No steps to complete
    }

    if (onboardingStepsDone.length === 0) {
        return false; // No steps completed
    }

    // Get all step slugs from available steps
    const allStepSlugs = allOnboardingSteps
        .map((step) => step?.slug)
        .filter(Boolean);

    // Check if all required steps are in the done steps
    return allStepSlugs.every((slug) => onboardingStepsDone.includes(slug));
};
